/* eslint-disable camelcase */
import axios from 'axios';
import {
  USER_ROLE_ENDPOINT, USER_ROLE_ENDPOINT_REGENERATE_PASSWORD
} from '@dynameat/constants';

export const userRoleListRequest = () => axios.get(USER_ROLE_ENDPOINT(), {
  params: { page_size: 0 }
});
export const createUserRoleRequest = (userRole) => axios.post(USER_ROLE_ENDPOINT(), userRole);
export const updateUserRoleRequest = (username, userRole) => axios.patch(USER_ROLE_ENDPOINT(username), userRole);
export const deleteUserRoleRequest = (username) => axios.delete(USER_ROLE_ENDPOINT(username));
export const regeneratePasswordUserRoleRequest = (username) => axios.post(USER_ROLE_ENDPOINT_REGENERATE_PASSWORD(username));
